import React, { Component} from 'react';
import {reduxForm, Field} from 'redux-form';
import { connect} from 'react-redux';
import { FormGroup, Col, Label, Input, Row, Button } from "reactstrap";
import moment from 'moment'
import momentLocalizer from 'react-widgets-moment-localizer'
import  { Link, Redirect } from 'react-router-dom';
import Select from "react-select";
import BillingValidation from "../../validation/BillingValidation";


momentLocalizer(moment);

const mapStateToProps = (state) => {
    let user = JSON.parse(localStorage.getItem('user'));
    return {
        initialValues: {
            type: state.billings.getBillingDetail.type,
            description: state.billings.getBillingDetail.description,
            date: moment(state.billings.getBillingDetail.date).format('YYYY-MM-DD'),
            amount: state.billings.getBillingDetail.amount || 0,
            billing_status: state.billings.getBillingDetail.billing_status || 'en_attente',
            user_id: state.billings.getBillingDetail.user_id ? ({
                label: (state.billings.getBillingDetail.user_firstname ?
                    state.billings.getBillingDetail.user_firstname : '') + ' ' +
                    (state.billings.getBillingDetail.user_lastname ? state.billings.getBillingDetail.user_lastname : ''),
                value : state.billings.getBillingDetail.user_id
            }): user.id ? {
                label: (user.firstname ? user.firstname : '') + ' ' + (user.lastname ? user.lastname : ''),
                value : user.id
            }: null,
            user_firstname: state.billings.getBillingDetail.user_firstname || user.firstname,
            user_lastname: state.billings.getBillingDetail.user_lastname || user.lastname,
            customer_id: state.billings.getBillingDetail.customer_id ? {
                label: (state.billings.getBillingDetail.customer_firstname ?
                    state.billings.getBillingDetail.customer_firstname : '' )+ ' ' +
                    (state.billings.getBillingDetail.customer_lastname ? state.billings.getBillingDetail.customer_lastname : ''),
                value : state.billings.getBillingDetail.customer_id
            }: state.customers.getCustomerDetail._id ? {
                    label: (state.customers.getCustomerDetail.firstname ?
                        state.customers.getCustomerDetail.firstname : '' )+ ' ' +
                        (state.customers.getCustomerDetail.lastname ? state.customers.getCustomerDetail.lastname : ''),
                    value: state.customers.getCustomerDetail._id,
                }: null,
            customer_firstname: state.billings.getBillingDetail.customer_firstname || state.customers.getCustomerDetail.firstname,
            customer_lastname: state.billings.getBillingDetail.customer_lastname || state.customers.getCustomerDetail.lastname,
        },
        getAllUsers: state.users.getAllUsers ? state.users.getAllUsers : JSON.parse(localStorage.getItem('allUsers')),
        getAllCustomers: state.customers.getAllCustomers ? state.customers.getAllCustomers : JSON.parse(localStorage.getItem('allCustomers')),
        getUserConnected: JSON.parse(localStorage.getItem('user')),
        getUserToken: localStorage.getItem('token'),
        getBillingDetail: state.billings.getBillingDetail,
        getResponDataBilling: state.billings.getResponDataBilling,
        errorResponDataBilling: state.billings.errorResponDataBilling,
    };
};

const renderFieldInput = ({
                              input,
                              type,
                              placeholder,
                              label,
                              disabled,
                              readOnly,
                              meta: { touched, error, warning },
                          }) => (
    <Row>
        <Col md="12">
            <Label htmlFor="{input}" className="col-form-label">
                {label}
            </Label>
        </Col>
        <Col md="12">
            <Input
                {...input}
                type={type}
                placeholder={placeholder}
                disabled={disabled}
                readOnly={readOnly}
            />
            {touched &&
            ((error && <p style={{ color: "red" }}>{error}</p>) ||
                (warning && <p style={{ color: "brown" }}>{warning}</p>))}
        </Col>
    </Row>
);


class BillingFormComponent extends Component {

    render()
    {
        if(!this.props.getUserConnected || !this.props.getUserToken){
            return <Link to="/"/>
        }
        const renderFieldSelectStatus = ({
                                             input,
                                             type,
                                             placeholder,
                                             label,
                                             disabled,
                                             readOnly,
                                             meta: { touched, error, warning },
                                         }) => (
            <Row>
                <Col md="12">
                    <Label htmlFor="{input}" className="col-form-label">
                        {label}
                    </Label>
                </Col>
                <Col md="12">
                    <Input
                        {...input}
                        type={type}
                        placeholder={placeholder}
                        disabled={disabled}
                        readOnly={readOnly}
                    >
                        <option  value='en_attente'>En attente</option>
                        <option  value='paye'>Payé</option>
                        <option  value='annule'>Annulé</option>
                        <option  value='en_veille'>En veille</option>
                    </Input>
                    {touched &&
                    ((error && <p style={{ color: "red" }}>{error}</p>) ||
                        (warning && <p style={{ color: "brown" }}>{warning}</p>))}
                </Col>
            </Row>
        );

/*const renderFieldSelectType = ({
                                             input,
                                             type,
                                             placeholder,
                                             label,
                                             disabled,
                                             readOnly,
                                             meta: { touched, error, warning },
                                         }) => (
            <Row>
                <Col md="12">
                    <Label htmlFor="{input}" className="col-form-label">
                        {label}
                    </Label>
                </Col>
                <Col md="12">
                    <Input
                        {...input}
                        type={type}
                        placeholder={placeholder}
                        disabled={disabled}
                        readOnly={readOnly}
                    >
                        <option value={'Rappel'}>Rappel</option>
                        <option value={'Envoie Doc'}>Envoie Doc</option>
                        <option value={'Rendez-vous telephonique'}>Rendez-vous téléphonique</option>
                        <option value={'A suivre'}>A suivre</option>
                        <option value={'Autre'}>Autre</option>
                    </Input>
                    {touched &&
                    ((error && <p style={{ color: "red" }}>{error}</p>) ||
                        (warning && <p style={{ color: "brown" }}>{warning}</p>))}
                </Col>
            </Row>
        );

 */

        const renderDateTimePicker = ({
                                          input,
                                          type,
                                          placeholder,
                                          label,
                                          disabled,
                                          readOnly,
                                          defaultValue,
                                          meta: { touched, error, warning },
                                      }) => (
            <Row>
                <Col md="12">
                    <Label for="status">
                        {label}
                    </Label>
                </Col>
                <Col md="12">
                    <Input
                        {...input}
                        type="date"
                        name="date"
                        defaultValue={this.props.getBillingDetail.date ?
                            moment(this.props.getBillingDetail.date).format('YYYY-MM-DD')
                            : moment().format('YYYY-MM-DD') }
                        placeholder="date">
                    </Input>
                    {touched &&
                    ((error && <p style={{ color: "red" }}>{error}</p>) ||
                        (warning && <p style={{ color: "brown" }}>{warning}</p>))}
                </Col>
            </Row>
        );

        const renderFieldSelectUserId = ({
                                             input,
                                             name,
                                             placeholder,
                                             label,
                                             options,
                                             id,
                                             meta: { touched, error, warning },
                                         }) => (
            <Row>
                <Col md="12">
                    <Label htmlFor="{input}" className="col-form-label">
                        {label}
                    </Label>
                </Col>
                <Col md="12">
                    <Select
                        placeholder={placeholder}
                        {...input}
                        //id={id}
                        //name={name}
                        options={options}
                        //value={input.value}
                        onChange={(value) => input.onChange(value)}
                        onBlur={() => input.onBlur()}
                        isClearable
                        isSearchable
                        //onChange={value => input.onChange(value)}
                        //value={options.filter(option => option.value === this.props.getCustomerDetail.customer_id)}
                        //options={options}
                    />
                    {touched &&
                    ((error && <p style={{ color: "red" }}>{error}</p>) ||
                        (warning && <p style={{ color: "brown" }}>{warning}</p>))}
                </Col>
            </Row>
        );

        let userId = [];

        this.props.getAllUsers.map((user) => {
            userId.push({
                label: (user.firstname ? user.firstname : '') + ' ' +  (user.lastname ? user.lastname : ''),
                value: user._id
            })})

        const renderFieldSelectCustomerId = ({
                                                 label,
                                                 options,
                                                 input,
                                                 placeholder,
                                                 id,
                                                 name,
                                                 defaultValue,
                                                 meta: { touched, error, warning },
                                             }) => (

            <Row>
                <Col md="12">
                    <Label htmlFor="{input}" className="col-form-label">
                        {label}
                    </Label>
                </Col>

                <Col md="12">
                    <Select
                        placeholder={placeholder}
                        {...input}
                        //id={id}
                        //name={name}
                        options={options}
                        //value={input.value}
                        onChange={(value) => input.onChange(value)}
                        onBlur={() => input.onBlur()}
                        isClearable
                        isSearchable
                        //onChange={value => input.onChange(value)}
                        //value={options.filter(option => option.value === this.props.getCustomerDetail.customer_id)}
                        //options={options}
                    />
                    {touched &&
                    ((error && <p style={{ color: "red" }}>{error}</p>) ||
                        (warning && <p style={{ color: "brown" }}>{warning}</p>))}
                </Col>
            </Row>
        );

        let customerId = [];

        this.props.getAllCustomers.map((customer) => {
            customerId.push({
                label: (customer.firstname ? customer.firstname : '') + ' ' +  (customer.lastname ? customer.lastname : ''),
                value: customer._id
            })})

        /*
        --------------------- Trier le tableau par label-----------------------
        customerId.sort(sortFunction);

        function sortFunction(a, b) {
            if (a.label === b.label) {
                return 0;
            }
            else {
                return (a.label < b.label) ? -1 : 1;
            }
        }*/

        return (
            <form onSubmit={this.props.handleSubmit}>
                <FormGroup row>
                    <Col md="6">
                        <FormGroup>
                            <Field
                                type="text"
                                component={renderFieldInput}
                                name="type"
                                label="Type : "
                                placeholder="Type de facturation"/>
                        </FormGroup>
                    </Col>

                    <Col md="6">
                        <FormGroup>
                            <Field
                                type="textarea"
                                component={renderFieldInput}
                                label="Description : "
                                placeholder="Description de la facturation"
                                name="description"/>
                        </FormGroup>
                    </Col>

                    <Col md="4">
                        <FormGroup>
                            <Field
                                type="number"
                                component={renderFieldInput}
                                name="amount"
                                label="Montant : "
                                placeholder="Montant de la facture"/>
                        </FormGroup>
                    </Col>

                    <Col md="4">
                        <FormGroup>
                            <Field
                                component={renderFieldSelectStatus}
                                label="Status de la facture :"
                                type="select"
                                name="billing_status"/>
                        </FormGroup>
                    </Col>

                    <Col md="4">
                        <FormGroup>
                            <Field
                                name="date"
                                type="date"
                                label="Date du jour ou la facture doit être payé :"
                                component={renderDateTimePicker}/>
                        </FormGroup>
                    </Col>

                    <Col md="6">
                        <FormGroup>
                                <Field
                                    component={renderFieldSelectUserId}
                                    label="Crée par l'utilisateur :"
                                    options={userId}
                                    name="user_id"
                                    defaultValue={this.props.getUserConnected.id}/>
                        </FormGroup>
                    </Col>

                    <Col md="6">
                        <FormGroup>
                            <Field
                                component={renderFieldSelectCustomerId}
                                label="Relier au client: "
                                placeholder="Relier au client: "
                                options={customerId}
                                name="customer_id"/>
                        </FormGroup>
                    </Col>
                </FormGroup>

                <FormGroup row className="my-0">
                    <Col md="12">
                        <FormGroup>
                            <Button
                                color="dark"
                                type="submit"
                                disabled={this.props.submitting}
                            >
                                Valider
                            </Button>
                        </FormGroup>
                    </Col>
                </FormGroup>
            </form>
        );
    }
}

  BillingFormComponent = reduxForm({
    form: 'formCreateBilling',
    validate: BillingValidation,
    enableReinitialize: true,
})(BillingFormComponent);

export default connect(mapStateToProps, null)(BillingFormComponent)